const getFullAddress = (address) => {
  return `${address.streetAddress || ''} ${address.streetNumber || ''}, ${
    address.postalCode || ''
  },  ${address.locality || ''} ${address.region || ''}`;
};

export { getFullAddress };
